import { i18n } from "@/i18n";

export default {
  path: "/download-file/:action/:base64file/:fileName",
  name: "downloadFile",
  component: () => import(/* webpackChunkName: "download" */ "@/views/Download/DownloadView.vue"),
  meta: {
    authRequired: false,
    title: i18n.global.t("page.download.title"),
    breadcrumb: true,
  },
};
